import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const CTA_LABELS = {
  nav: "Header navigation",
  "nav-mobile": "Header navigation (mobile)",
  hero: "Hero banner",
  "hero-mobile": "Hero banner (mobile)",
  "benefits-banner": "Gen 2 at a glance banner",
  "upgrade-banner": "Upgrade now banner",
  "matrix-recommender": "Replacement matrix",
  "fit-check": "Fit Check result",
  direct: "Direct (no CTA click)",
};

export const ctaLabel = (key) => {
  if (!key) return "—";
  return CTA_LABELS[key] || key.replace(/-/g, " ").replace(/\b\w/g, (ch) => ch.toUpperCase());
};

export const trackCta = (location) => {
  try {
    sessionStorage.setItem("cta_source", location);
  } catch {}
  axios.post(`${API}/track/cta`, { location }).catch(() => {});
};

export const getCtaSource = () => {
  try {
    return sessionStorage.getItem("cta_source");
  } catch {
    return null;
  }
};
